/* eslint-disable @typescript-eslint/no-explicit-any */
import { invoiceControlStatusConfig, InvoiceProjectByStatus } from 'entities';

import { compareByName, sortByProperty } from 'utils/array';

const rankers: Record<
  string,
  { check: (a: InvoiceProjectByStatus) => any; points: number; addWarning?: boolean }
> = {
  missingPaymentToBeReady: {
    points: 10,

    check: ({ status, readyToInvoice, type }) =>
      [
        //
        status === invoiceControlStatusConfig.waitingInvoiceInfo.code,
        readyToInvoice,
        !type,
      ].every(Boolean),

    addWarning: true,
  },

  readyToInvoice: {
    points: 9,

    check: ({ status }) => status === invoiceControlStatusConfig.readyToInvoice.code,

    addWarning: true,
  },

  partiallyInvoiced: {
    points: 8,

    check: ({ status }) => status === invoiceControlStatusConfig.partiallyInvoiced.code,
  },

  waitingToBeSent: {
    points: 7,

    check: ({ status, readyToInvoice }) =>
      [
        //
        status === invoiceControlStatusConfig.waitingInvoiceInfo.code,
        !readyToInvoice,
      ].every(Boolean),
  },
};

export function sortControls(controls: InvoiceProjectByStatus[]) {
  const groupedByImportance = Object.values(rankers)
    .sort((a, b) => b.points - a.points)
    .map(({ check, addWarning }) =>
      sortByProperty(controls.filter(check), 'project', { project: compareByName }).map((p) => ({
        ...p,
        addWarning,
      })),
    );

  return groupedByImportance.flat();
}

export function hasWarning(controls: InvoiceProjectByStatus[]) {
  const warningChecks = Object.values(rankers).filter((r) => r.addWarning);

  return controls.some((control) => warningChecks.some(({ check }) => check(control)));
}
